function findHeadingById(id) {
  const heading = document.getElementById(id);

  if (heading) {
    return heading;
  }

  return null;
}

const navLinks = document.querySelectorAll('.article-main__nav-item');
navLinks.forEach((link) => {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    const id = link.getAttribute('data-handle');
    const heading = findHeadingById(id);
    if (heading) {
    const position = heading.offsetTop - (window.innerHeight - heading.offsetHeight) / 4;
    window.scrollTo({
      top: position,
      behavior: 'smooth'
    });
    }
  });
});



window.addEventListener('scroll', () => {
  let scrollDistance = window.scrollY;

  if (window.innerWidth > 768) {
    document.querySelectorAll('.nm-nav-heading').forEach((el, i) => {
      if (el.offsetTop - 250 <= scrollDistance) {
        document.querySelectorAll('.article-main__nav-item').forEach((el) => {
          if (el.classList.contains('js-active')) {
            el.classList.remove('js-active');
          }
        });

        document.querySelectorAll('.article-main__nav-item')[i].classList.add('js-active');

        navScroll();
      }
    });
  }
});

function navScroll() {
  let listNavigation = document.querySelector(".article-main__navigation");
  let activeItem = Array.from(navLinks).findIndex(item => item.classList.contains("js-active")) + 2;
  let heightToItem = 0;

  for (let i = 0; i < activeItem; i++) {
    heightToItem = heightToItem + navLinks[i].clientHeight;
  }

  listNavigation.scrollTop = (heightToItem - listNavigation.clientHeight) > 0 ? heightToItem - listNavigation.clientHeight : 0;
}

if(document.querySelector(".article-main__navigation-btn")) {
  let navigationOpener = document.querySelector(".article-main__navigation-btn");
  let listNavigation = document.querySelector(".article-main__navigation");

  navigationOpener.addEventListener("click", (ev) => {
    listNavigation?.classList.toggle('is-show');
    navLinks.forEach(link => {
      link.classList.toggle("is-show");
    });

    //navigationOpener.remove();
  })
}